import Spacer from '@components/Ui/Spacer'
import Text from '@components/Ui/Text'
import Icon from '@components/Ui/Icon'
import styles from './Error.scss'

const Error = ({ children }) => (
  <div className={styles.base}>
    <div className={styles.icon}>
      <Icon type="close" size="18" />
    </div>
    <Spacer vertical scale="0.5" />
    <Text className={styles.content} type="robo_md_bold">
      {children}
    </Text>
  </div>
)

Error.defaultProps = {}
Error.propTypes = {}

export default Error
